document.addEventListener("DOMContentLoaded", () => {
	setTimeout(() => {
		const productMedia = document.querySelector(".js-product-filtered-media");
		if (!productMedia) return;

		const productMediaSwiperEl = productMedia.querySelector(".js-product-media-swiper");
		const productMediaThumbsSwiperEl = productMedia.querySelector(".js-product-swiper-thumbs");
		if (!productMediaSwiperEl || !productMediaThumbsSwiperEl) return;

		const featuredMediaThumbsSwiper = new Swiper(productMediaThumbsSwiperEl, {
			freeMode: false,
			draggable: true,
			slidesPerView: 5.25,
			spaceBetween: 10,
			centeredSlides: false,
			mousewheel: false,
			a11y: true,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			grabCursor: true,
			breakpoints: {
				991: {
					slidesPerView: 5.25,
					autoHeight: false,
				}
			}
		});

		const productMediaSwiper = new Swiper(productMediaSwiperEl, {
			freeMode: false,
			draggable: true,
			slidesPerView: 1,
			centeredSlides: false,
			a11y: true,
			autoHeight: true,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			/*navigation: {
				nextEl: '.product-media__swiper-button-next',
				prevEl: '.product-media__swiper-button-prev',
			},*/
			thumbs: {
				swiper: featuredMediaThumbsSwiper,
			},
			grabCursor: true,
			loop: false
		});
	}, 100);
});